import React, { createContext, useContext, useState } from "react";
import translations, { Lang } from "./translations";

type Translation = typeof translations[Lang];

interface LanguageContextValue {
    lang: Lang;
    t: Translation;
    toggleLang: () => void;
}

const LanguageContext = createContext<LanguageContextValue | null>(null);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [lang, setLang] = useState<Lang>("en");
    const toggleLang = () => setLang(l => (l === "he" ? "en" : "he"));
    const t = translations[lang];
    return (
        <LanguageContext.Provider value={{ lang, t, toggleLang }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
    return ctx;
};
